
  
  import { ModelSelect, ModelListSelect  } from 'vue-search-select'
  import 'vue-search-select/dist/VueSearchSelect.css'
  
  
  import UMUM from '../../library/umum'
  import DATAMASTER from '../../library/dataMaster'
  import FETCHING from '../../library/fetching'

  
  
  import Joi from "joi";
  
  const schema = Joi.object().keys({
      username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
      password: Joi.string().min(6).required(),
    });
  
  
  
  export default {
    components: {
        ModelSelect, ModelListSelect, 
    },
  
    data() {
      return {
  
        status:'',
        
  
        form : {
          id : '',
          program_id : '',
          kegiatan_id : '',
          setor : '',
          keterangan : '',
          tahun : '',
          des_kel_id : '',
          nama_des_kel : '',
        },
  
         lampiran : {
            id : '',
            program_id : '',
            kegiatan_id : '',
            des_kel_id : '',
            uraian : '',
            tahun : '',
            keterangan : '',
            file : null,
            file_type : '',
             file_old : null,
          },
  
  
          filterku : {
            tahun : '',
            des_kel_id : '',
            kecamatan_id : '',
            program_id : '',
        },
  
        folder : {
            id : '',
            status : 0,
            notice : '',
          },

          tahun: [
				      { id: '', tahun: 'Pilih Tahun'},
				      { id: 2021, tahun: '2021'},
				      { id: 2022, tahun: '2022'},
				      { id: 2023, tahun: '2023'},
				      { id: 2024, tahun: '2024'},
				      { id: 2025, tahun: '2025'},
				      { id: 2026, tahun: '2026'},
		    ],

       
      
        list_data : [],
        list_klp : [],
        lokasi : [],
        checkAll : true,
  
        errorMessage: '',
        signingUp : false,
      
        UMUM : UMUM,
        
        DATAMASTER : DATAMASTER,
        FETCHING : FETCHING,
  
        nm_jabatan : '',
        nm_unit_kerja : '',
  
        instansi_id : '',
        unit_kerja : '',
        unit_kerja_full : '',
        unit_kerja_edit : '',
  
        page_first: 1,
        page_last: 0,
        page_limit : 10,
        cari_value: "",
  
        cek_load_data : true,
  
  
        mdl_add: false,
        mdl_edit: false,
        mdl_edit_file: false,
        mdl_hapus : false,
        mdl_hapus_lampiran : false,
        mdl_add_file : false,
        mdl_add_kgb : false,
        
        mdl_lihat : false,
        mdl_list : false,
        mdl_open : false,
        mdl_open_kgb : false,
        mdl_list_hasil : false,
        mdl_keterangan : false,
        mdl_keterangan_folder : false,
  
  
        mdl_list_direktori: false,
  
        file_path: this.$store.state.url.URL_APP + "uploads/",


        list_program : [],

        list_kegiatan : [],
  
  
  
  
  
  
  
  
        tipe: 0,
        cariNamaPegawai : '',
        list_kgb_asn : [],
        list_lampiran : [],
        list_hasil:[],
      }
    },
    methods: {
  
//      
        getKegiatan: function() {

        fetch(this.$store.state.url.URL_PRO_KEG + "viewKegiatanx", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    des_kel_id : this.filterku.des_kel_id,
                    program_id : this.form.program_id,
                    tahun: this.form.tahun
            })
            })
                .then(res => res.json())
                .then(res_data => {
                // console.log(res_data);
                
                    this.list_kegiatan = res_data;
                    console.log("asdas" + res_data);
            });
        },

        getProgram: function() {

            fetch(this.$store.state.url.URL_PRO_KEG + "viewProgram", {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                    des_kel_id : this.filterku.des_kel_id,
                    tahun: this.form.tahun
                })
                })
                    .then(res => res.json())
                    .then(res_data => {
                    // console.log(res_data);
                    
                        this.list_program = res_data;
                        // console.log(res_data);
                });
            },
  
  
  
  
      getView : function(){
        this.cek_load_data = true;
        fetch(this.$store.state.url.URL_PAJAK + "view", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,
                page_limit : this.page_limit,
                kecamatan_id : this.filterku.kecamatan_id,
                des_kel_id : this.filterku.des_kel_id,
                tahun : this.filterku.tahun,
                tipeku : this.tipeku,
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.cek_load_data = false;
                // console.log(this.list_data + "siap");
        });
      },
  
      getView1 : function(a){
        fetch(this.$store.state.url.URL_KGB + "view1", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id_kgb : a,
            })
        })
            .then(res => res.json())
            .then(res_data => {
              this.list_kgb_asn = res_data;
  
              this.uraian = this.list_kgb_asn[0].uraian;
              this.total_file = this.list_kgb_asn.map(total => total.proses).reduce((acc, amount) => acc + amount);
              // this.nama_keterangan = this.list_kgb_asn[0].keterangan;
              
        });
      },

      addData : function() {
        
            fetch(this.$store.state.url.URL_PAJAK + "addData", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                form : this.form,
            })
                
            }).then(res_data => {
            this.getView();
            this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
            });


        },

      editData: function() {
          fetch(this.$store.state.url.URL_PAJAK + "editData", {
              method: "POST",
              headers: {
                  'content-type' : 'application/json',
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
              form : this.form
            })
          }).then(res_data => {
              this.Notify('Sukses Mengubah Data', 'primary', 'check_circle_outline');
              this.getView();
          });
      },
  
      removeData : function(idnya){
        fetch(this.$store.state.url.URL_PAJAK + "removeData", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({id : this.form.id})
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
          });
      },
  
      removeDataLampiran : function(idnya){
        fetch(this.$store.state.url.URL_KGB + "removeDataLampiran", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.lampiran)
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
              var a = this.lampiran.kgb_id
                var b = this.lampiran.unit_kerja_id 
                this.getLampiran(a, b); 
                this.getView1(data.id);
          });
      },
      removeDataAsn : function(idnya){
        fetch(this.$store.state.url.URL_KGB + "removeDataAsn", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.lampiran)
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
              var a = this.lampiran.kgb_id
                var b = this.lampiran.unit_kerja_id 
                this.getLampiran(a, b); 
                this.getView1(data.id);
          });
      },
  
      selectData : function(data){
          // console.log(data)
          this.form.id = data.id;
          this.form.program_id = data.program_id;
          this.form.program_id = data.program_id;
          this.form.kegiatan_id = data.kegiatan_id;
          this.form.setor = data.setor;
          this.form.tahun = data.tahun;
          this.form.keterangan = data.keterangan;
          this.form.des_kel_id = data.des_kel_id;
          this.form.nama_des_kel = data.nama_des_kel;
      },
  
        select2(data){
          this.lampiran.direktori_id = data.id
          this.lampiran.program_id = data.program_id
          this.lampiran.kegiatan_id = data.kegiatan_id
          this.lampiran.des_kel_id = data.des_kel_id
          this.lampiran.tahun = data.tahun

          console.log("cek " + data.id);
          

          this.getLampiran(data.id);
        },
  
        getTanggapan : function(kgb, nip){
          
            fetch(this.$store.state.url.URL_KGB + "hasil", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    kgb_id : kgb,
                    nip : nip,
  
                })
            })
                .then(res => res.json())
                .then(res_data => {
                //   console.log("AAAAAAAAAAAA " + res_data[0])
                  this.list_hasil = res_data.data;
            });
          },
  
        selectLampiran : function(data){
          // console.log(data.file + "asubabi");
          
          this.lampiran.id = data.id;
          this.lampiran.direktori_id = data.direktori_id;
          this.lampiran.des_kel_id = data.des_kel_id;
          this.lampiran.program_id = data.program_id;
          this.lampiran.kegiatan_id = data.kegiatan_id;
          this.lampiran.keterangan = data.keterangan;
          this.lampiran.file_old =  data.file
          this.lampiran.file = this.lampiran.file
          },
  
        getLampiran : function(direktori){
  
          fetch(this.$store.state.url.URL_PAJAK + "viewLampiran", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  direktori_id : direktori,
                  des_kel_id :  this.lampiran.des_kel_id,
                  kegiatan_id :  this.lampiran.kegiatan_id,
              })
          })
              .then(res => res.json())
              .then(res_data => {
                console.log("asgdajhsda" + res_data)
                this.list_lampiran = res_data
          });
        },
  
        addLampiran: function(){
  
          var formData = new FormData();
          formData.append('pb', JSON.stringify(this.lampiran));
          formData.append('file', this.lampiran.file);
  
          fetch(this.$store.state.url.URL_PAJAK + 'addDataLampiran', {
              method: "POST",
              headers: {
                  authorization: "kikensbatara " + localStorage.token
              },
              body: formData
              }).then(res_data => {
                
                // this.lampiran.direktori_id
                this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
                this.getLampiran(direktori);
          });
          },
  
  
          addLampiranx: function(){
  
          var formData = new FormData();
          formData.append('pb', JSON.stringify(this.lampiran));
          formData.append('file', this.lampiran.file);
  
          fetch(this.$store.state.url.URL_PAJAK + 'addDataLampiranx', {
              method: "POST",
              headers: {
                  authorization: "kikensbatara " + localStorage.token
              },
              body: formData
              }).then(res_data => {
                
                // this.lampiran.direktori_id
                  this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
                var a = this.lampiran.direktori_id
                var b = this.lampiran.kegiatan_id 
                this.getLampiran(a, b); 
                // this.getView1(data.id);
          });
          },
  
  
            editLampiran: function(){
  
            var formData = new FormData();
            formData.append('pb', JSON.stringify(this.lampiran));
            formData.append('file', this.lampiran.file);
            // formData.append('fileOld', this.fileOld);
  
            fetch(this.$store.state.url.URL_PAJAK + 'editDataLampiran', {
                method: "POST",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
                }).then(res_data => {
                  this.Notify('Sukses Mengubah Data', 'primary', 'check_circle_outline');
                  var a = this.lampiran.direktori_id
                  var b = this.lampiran.kegiatan_id 
                  this.getLampiran(a, b); 
            });
            },


            // ====================================== CONTOH eDOC ====================================
      async onChangexKecamatan(){
        
        
        await DATAMASTER.getKecamatanAsync("");
        this.onChangexDeskel();
      },
      async onChangexDeskel(){
        // console.log("yyyyyyyyyyyy");
        var deskelx = await DATAMASTER.getDeskelAsync(this.filterku.kecamatan_id)
        // console.log("xxxxxxxxxxxxx");
        // console.log(deskelx[0].id);
      
          // this.filterku.des_kel_id = deskelx[0].id
        
        
        // console.log("xxxxxxxxxxxxx");
        // console.log(this.filterku.des_kel_id);
        this.getView();
      },
  
      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
  
          indexing : function(index){
              var idx = ((this.page_first-1)*this.page_limit)+index
              return idx;
          },
  
          selectFolder : function(data){ 
           this.folder.id = data.id;
            this.folder.status = data.status;
            this.folder.notice = data.notice;
  
        },

       
       
  
  
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },
  
          selectBiodata (item) {
            return `${item.nama} | NIP. ${item.nip}`
          },
  
  
          getAsyncPost : async function() {
            this.list_klp = await FETCHING.postMasterKlpMenu();
          },
  
          cariNama : async function(){
            this.$store.state.list_biodata = await FETCHING.FETCH_POST(this.$store.state.url.URL_simpeg_biodata + "cariNama", {cari : this.cariNamaPegawai, unit_kerja : this.unit_kerja} )
            this.getView()
          },
  
      // ====================================== PAGINATE ====================================
    },
  
    mounted () {

    let profilex = JSON.parse(localStorage.profile);
    let profile = profilex.profile;
    DATAMASTER.getDeskelAsync(this.filterku.des_kel_id);
    this.form.des_kel_id = profile.des_kel_id;
    this.filterku.kecamatan_id = profile.kecamatan_id;
    this.filterku.des_kel_id = profile.des_kel_id;
    this.tipeku = profile.menu_klp;
    this.form.nama_des_kel = profile.nama_des_kel;

    //   console.log("======" + this.filterku.des_kel_id);
      

      const d = new Date();
      let year = d.getFullYear();
      this.form.tahun = year;
      this.filterku.tahun = year;

    //   console.log(profile)


      DATAMASTER.getTahun();


      this.onChangexKecamatan();
      this.getProgram();
    //   this.getKegiatan();


  
    },
  }
  